import { ChatbotCookiePrefix, JwtCookie } from '@/enums/cookies'
import Cookies from 'js-cookie'

export const setCookie = (name: string, value: string, options?: Cookies.CookieAttributes) => {
  Cookies.set(name, value, { ...options, expires: new Date(Date.now() + 604800) })
}

export const getCookie = (name: string) => {
  return Cookies.get(name)
}

export const removeCookie = (name: string, options?: Cookies.CookieAttributes) => {
  Cookies.remove(name, { ...options, domain: getCookieDomain(name) })
}

export const getValidJwtCookie = (): string | undefined => {
  const cookie = Cookies.get(JwtCookie)
  if (!cookie) return undefined

  try {
    const parts = cookie.split('.')
    if (parts.length < 2) return undefined

    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const decoded = JSON.parse(atob(payload))

    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      Cookies.remove(JwtCookie)
      return undefined
    }

    return cookie
  } catch {
    return undefined
  }
}

export const getCookieDomain = (name: string) => {
  const host = window.location.host

  const isChatBotCookie = name.includes(ChatbotCookiePrefix)

  console.log({ isChatBotCookie })

  if (host.includes('localhost') || isChatBotCookie) {
    console.log('localhost or isChatBotCookie')
    return undefined
  }

  if (host.includes('customerservice')) {
    console.log('customerservice')
    return host.replace('customerservice', '')
  }

  console.log({ host })

  return host
}
